import {EARRING} from "../../constants";

/**
 * Given on the state, set the right variation on the product
 */

export default function variantConnector(store) {
    let {earringInput, goldColor, earringQuantity} = store.getState();

    let [earring1Line1, earring1Line2, earring2Line1, earring2Line2] = earringInput;

    if (!/au/.test(location.hostname)) {
        console.warn('Variant connector is off in local environment');
    }

    if (
        (earringQuantity === EARRING.ONE && earring1Line1.length === 0) ||
        (earringQuantity === EARRING.PAIR && (earring1Line1.length === 0 || earring2Line1.length === 0))
    ) {
        timber.productPage({variant: null});
        return;
    }

    let lettersUsed = (earringQuantity === EARRING.ONE) ? earring1Line1.length + earring1Line2.length : earring1Line1.length + earring1Line2.length + earring2Line1.length + earring2Line2.length;
    let sku = `au-letter-earring-${quantityToAbbreviation(earringQuantity)}-${lettersUsed}`;

    if (!window.productVariants) {
        console.error(sku);
        throw new Error('Product variants hash is missing in window object');
    }

    let selectedVariant = window.productVariants.find((variant) => variant.sku === sku);

    /** Code below mimics product-options code **/

    timber.productPage({
        variant: selectedVariant
    });

    if (selectedVariant) {
        document.querySelector("[data-js='master-select']").value = selectedVariant.id;
        document.getElementById('gold-color').value = goldColor.description;
        document.getElementById('earring-quantity').value = earringQuantity.description;
        if (earringQuantity === EARRING.ONE) {
            document.getElementById('earring-text').value = `Line one: ${earring1Line1.toUpperCase()} / Line two: ${earring1Line2.toUpperCase()}`;
        } else {
            let value = `Earring one: ${earring1Line1.toUpperCase()}`;
            if (earring1Line2.length) value += `/${earring1Line2.toUpperCase()}`;
            value += ` Earring two: ${earring2Line1.toUpperCase()}`;
            if (earring2Line2.length) value += `/${earring2Line2.toUpperCase()}`;
            document.getElementById('earring-text').value = value;
        }

        if (window.affirm) {
            window.affirm.ui.ready(function () {
                if (document.querySelector('.affirm-as-low-as')) {
                    document.querySelector('.affirm-as-low-as').setAttribute('data-amount', selectedVariant.price);
                    window.affirm.ui.refresh();
                }
            });
        }

        window.selectedVariant = selectedVariant.title;
    }
}

function quantityToAbbreviation(quantity) {
    switch (quantity) {
        case EARRING.ONE:
            return 'one';
        case EARRING.PAIR:
            return 'pair';
    }
}
